import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { QUERY_KEY as PAYOUT_DEFINITIONS_QUERY_KEY } from '@/modules/core/queries/usePayoutDefinition.query';
import { QUERY_PAYOUT_DEFINITION_BY_ID } from '@/modules/ProcessingDefinition/PayoutDefinition/queries';

export interface UpdatePayoutDefinitionPayload {
  name: string;
  is_limited_use: boolean;
  mp_table_id: number | null;
  cov_table_id: number | null;
  allowed_services: {
    service_id: number;
    plans: {
      plan_template_id: number;
      order: number;
    }[];
  }[];
}

const useUpdatePayoutDefinitionQuery = (payoutDefinitionId: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (payload: UpdatePayoutDefinitionPayload) =>
      api.put(API_URL.PAYOUT_DEFINITIONS_BY_ID(payoutDefinitionId), payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [PAYOUT_DEFINITIONS_QUERY_KEY] });
        queryClient.invalidateQueries({ queryKey: [QUERY_PAYOUT_DEFINITION_BY_ID, payoutDefinitionId] });
      },
    }
  );

  return mutation;
};

export default useUpdatePayoutDefinitionQuery;
